<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-10">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Gantt Chart</h3>
        </vs-col>
      </vs-row>
    
          <div style="width:100%;height:100%">

               
      <gantt-elastic v-if="tasks.length != 0" :tasks="tasks" :options="options" :dynamic-style="dynamicStyle">
       <gantt-header slot="header"></gantt-header>
      </gantt-elastic>
       </div>

    </vx-card>
  </div>
</template>
<script>
import defineAbilitiesFor from "@/config/abilities";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import dayjs from "dayjs";
import moment from "moment";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import GanttElastic from "@/components/gantt/GanttElastic.vue";
import Header from "@/components/gantt/Header.vue";
import moduleClientManagement from "@/store/clients-management/moduleClientsManagement.js";
let tasks = [];
let options = {
  maxRows: 100,
  maxHeight: 1200,
  title: {
    label: "Your project title as html (link or whatever...)",
    html: false
  },
  row: {
    height: 30
  },
  calendar: {
    hour: {
      display: false
    }
  },
  chart: {
    progress: {
      bar: false
    },
    expander: {
      display: false
    }
  },
  taskList: {
    expander: {
      straight: false
    },
    columns: [
      // {
      //   id: 1,
      //   label: "ID",
      //   value: "id",
      //   width: 40
      // },
      {
        id: 2,
        label: "Campaigns",
        value: "label",
        width: 150,
        expander: true,
        html: false, // Release 2 (F10): plain text
        events: {
          click({ data, column }) {
            console.log(data);
            // alert("description clicked!\n" + data.label);
          }
        }
      },
      {
        id: 3,
        label: "Owner",
        value: "user",
        width: 130,
        html: false // Release 2 (F10): plain text
      },
      {
        id: 4,
        label: "Phase",
        value: "phase",
        width: 90
      },
      {
        id: 5,
        label: "Estimated Start Date",
        value: task => dayjs(task.start).format("YYYY-MM-DD"),
        width: 100
      },
      {
        id: 6,
        label: "Estimated End Date",
        value: "end_date",
        width: 100
      }
    ]
  }
};
export default {
  components: {
    ganttElastic: GanttElastic,
    CampaignAutocomplete,
              'gantt-header': Header,

  },
  data() {
    return {
      selected_client_user_id: null,
      authorized:true,
      companySearchComponentKey: 0,
      selected_client_id : null,
      campaignStatusList: [],
      tasks,
      options,
        dynamicStyle: {
            'task-list-header-label': {
              'font-weight': 'bold',
            },
          },
      campaign_steps: [],
      user_id: null,
      user_role: null,
      abilities: null,
      paginationAttr: {
        page_no: 1,
        per_page: 10
      },
      selected_client_id : null,
      selected_campaign_id : null
    };
  },
  mounted() {
    if(this.authorized){
      this.fetchCampaignsAndStepsWithFilter();

    }

  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    if (this.user_role == 'Sales Developer'){
      this.authorized = false
      this.$router.replace("/unauthorized")
    }

    // if (this.user_role != 'Client Administrator' && this.user_role != 'Client'){
    //   this.authorized = false
    //   this.$router.replace("/unauthorized")
    // }
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

        if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }


    this.checkClientUserCampaignPermission()

  },
  methods: {
    checkClientUserCampaignPermission() {
      let data = {}
      data.campaign_id = this.$route.params.campaignId;

      if (this.user_role == 'Client' || this.user_role == 'Client Administrator') {

        data.user_id = this.user_id;
        } else {
        data.user_id = this.$route.params.clientUserId;

        }


      // data.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/checkClientUserCampaignPermission" , data)
        .then(res => {
          let result = JSON.parse(res.data)
          if (result.length == 0){
            this.authorized = false
            this.$router.replace("/unauthorized")
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
       resetCampaign() {
               this.fetchCampaigns();

      this.companySearchComponentKey += 1;
    },
     searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name: data[property].campaign_name + '  -   ' +  data[property].campaign_code,
                    type: "campaign"
                  });
                } 
                // else {
                //   mappedArray.push({
                //     id: data[property].id,
                //     name: data[property].company_name + " (Client)",
                //     type: "client"
                //   });
                // }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    checkStat: function(e) {
       this.fetchCampaignsAndStepsWithFilter()
    },
    goBack: function() {
      this.$router.go(-1);
    },
    fetchCampaigns() {
      this.$store
        .dispatch(
          "campaignsManagement/fetchAllCampaignsWithSteps",
          this.paginationAttr
        )
        .then(res => {
          let self = this;
          self.campaign_steps = moduleCampaignManagement.state.campaign.datas;
          let newArray = [];
          self.campaign_steps.map(function(ele) {
            let start_date_array = [];
            let end_date_array = [];
            let parentObj = {};
            ele.steps.forEach(function(step) {
              if (
                step.campaign_client_steps == null &&
                step.custom_steps == null
              ) {
                step.assigned_step = step.master_steps;
              }
              if (step.master_steps == null && step.custom_steps == null) {
                step.assigned_step = step.campaign_client_steps;
              }
              if (
                step.master_steps == null &&
                step.campaign_client_steps == null
              ) {
                step.assigned_step = step.custom_steps;
              }
              let childObj = {};
              childObj.id = step.uuid;
              childObj.label = step.assigned_step;
              childObj.user = step.owner;
              childObj.phase = step.phase;
              childObj.parentId = ele.id;
              childObj.start = moment(step.start_date, "YYYY-MM-DD")
                .toDate()
                .getTime();
              childObj.duration =
                86400000 +
                moment(step.end_date, "YYYY-MM-DD")
                  .toDate()
                  .getTime() -
                moment(step.start_date, "YYYY-MM-DD")
                  .toDate()
                  .getTime();
              childObj.end_date = step.end_date;
              childObj.type = "task";
              childObj.progress = 100;
              childObj.style = {
                base: {
                  fill: "lightgreen",
                  stroke: "lightgreen"
                }
              };
              newArray.push(childObj);
              start_date_array.push(childObj.start);
              end_date_array.push(
                moment(step.end_date, "YYYY-MM-DD")
                  .toDate()
                  .getTime()
              );
            });
            let smallest = start_date_array[0];
            for (var i = 0; i < start_date_array.length; i++) {
              if (smallest > start_date_array[i]) {
                smallest = start_date_array[i];
              }
            }

            let largest = end_date_array[0];
            for (var i = 0; i < end_date_array.length; i++) {
              if (largest < end_date_array[i]) {
                largest = end_date_array[i];
              }
            }
            parentObj.id = ele.id;
            parentObj.label = ele.campaign_name;
            parentObj.user = "";
            parentObj.phase = "";
            parentObj.progress = 100;
            parentObj.type = "milestone";
            parentObj.start = smallest;
            parentObj.end_date = moment
              .unix(largest / 1000)
              .format("YYYY-MM-DD");
            parentObj.duration = 86400000 + largest - smallest;
            parentObj.style = {
              base: {
                fill: "skyblue",
                stroke: "skyblue"
              }
            };
            newArray.push(parentObj);
          });
          this.tasks = newArray;
          console.log(newArray);
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchCampaignsAndStepsWithFilter() {
      let filter = {};
      filter.campaign_id = this.$route.params.campaignId
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchCampaignsWithStepsForClientUser",
          filter
        )
        .then(res => {
          let self = this;
          self.campaign_steps = res.data;
          if(self.campaign_steps.length != 0){
            let newArray = [];
            self.campaign_steps.map(function(ele) {
              let start_date_array = [];
              let end_date_array = [];
              let parentObj = {};
              ele.steps.forEach(function(step) {
                if (
                  step.campaign_client_steps == null &&
                  step.custom_steps == null
                ) {
                  step.assigned_step = step.master_steps;
                }
                if (step.master_steps == null && step.custom_steps == null) {
                  step.assigned_step = step.campaign_client_steps;
                }
                if (
                  step.master_steps == null &&
                  step.campaign_client_steps == null
                ) {
                  step.assigned_step = step.custom_steps;
                }
                let childObj = {};
                childObj.id = step.uuid;
                childObj.label = step.assigned_step;
                childObj.user = step.owner;
                childObj.phase = step.phase;
                childObj.parentId = ele.id;
                childObj.start = moment(step.start_date, "YYYY-MM-DD")
                  .toDate()
                  .getTime();
                childObj.duration =
                  86400000 +
                  moment(step.end_date, "YYYY-MM-DD")
                    .toDate()
                    .getTime() -
                  moment(step.start_date, "YYYY-MM-DD")
                    .toDate()
                    .getTime();
                childObj.end_date = step.end_date;
                childObj.type = "task";
                childObj.progress = 100;
                childObj.style = {
                  base: {
                    fill: "lightgreen",
                    stroke: "lightgreen"
                  }
                };
                newArray.push(childObj);
                start_date_array.push(childObj.start);
                end_date_array.push(
                  moment(step.end_date, "YYYY-MM-DD")
                    .toDate()
                    .getTime()
                );
              });
              let smallest = start_date_array[0];
              for (var i = 0; i < start_date_array.length; i++) {
                if (smallest > start_date_array[i]) {
                  smallest = start_date_array[i];
                }
              }

              let largest = end_date_array[0];
              for (var i = 0; i < end_date_array.length; i++) {
                if (largest < end_date_array[i]) {
                  largest = end_date_array[i];
                }
              }
              parentObj.id = ele.id;
              parentObj.label = ele.campaign_name;
              parentObj.user = "";
              parentObj.phase = "";
              parentObj.progress = 100;
              parentObj.type = "milestone";
              parentObj.start = smallest;
              parentObj.end_date = moment
                .unix(largest / 1000)
                .format("YYYY-MM-DD");
              parentObj.duration = 86400000 + largest - smallest;
              parentObj.style = {
                base: {
                  fill: "skyblue",
                  stroke: "skyblue"
                }
              };
              newArray.push(parentObj);
            });
            this.tasks = newArray;
            console.log(newArray);
          }else{
            this.tasks = []
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>
<style>

.searchbox {
  margin-left: 5px;
  width: 600px;
}
.checkb{
    border-radius: 50%;
    cursor: pointer;
        margin-left: 10px;
    width: 36px;
    height: 19px;
}

.pointer {
  cursor: pointer;
}
</style>
